var rtlStyles = {"rtl":"qy9QI","ltr":"yNJsw"};

export { rtlStyles as r };
//# sourceMappingURL=rtl.rtlignore-b6186148.js.map
